import { API_GET_ONE_PROFESSIONAL_RFP_CURRENT_OFFER_SUCCESS, API_GET_ONE_PROFESSIONAL_RFP_OFFER_SUCCESS, } from '@/actions/rfpProOfferActions';
const initialState = {
    currentOne: {},
    one: {},
};
/**
 * コンサルタント案件提案 Reducer
 * @param state
 * @param result
 * @returns
 */
export const professionalRfpOffer = (state = initialState, result) => {
    const { meta, payload, type } = result;
    const { id } = (meta === null || meta === void 0 ? void 0 : meta.requestPayload) || {};
    switch (type) {
        case API_GET_ONE_PROFESSIONAL_RFP_OFFER_SUCCESS: {
            return Object.assign(Object.assign({}, state), { one: Object.assign(Object.assign({}, state.one), (id ? { [id]: payload } : {})) });
        }
        case API_GET_ONE_PROFESSIONAL_RFP_CURRENT_OFFER_SUCCESS: {
            return Object.assign(Object.assign({}, state), { currentOne: Object.assign(Object.assign({}, state.currentOne), (id ? { [id]: payload } : {})) });
        }
        default: {
            return state;
        }
    }
};
